import axios from "axios";

export const API_URL = "https://mw2c0cho61.execute-api.sa-east-1.amazonaws.com/production";

const HEADERS = { "Content-Type": "application/json;charset=utf-8" };

// Categorias de materiais (mesma lista usada pela API em /materials/categories)
export const MATERIAL_CATEGORIES = [
    { id: 10, name: "Boletins" },
    { id: 11, name: "Revistas" },
    { id: 12, name: "Legislação" },
    { id: 14, name: "Documentos" },
    { id: 15, name: "Faixas" },
    { id: 16, name: "Jornal" },
    { id: 17, name: "Convocatória" },
    { id: 18, name: "Carta Aberta" },
    { id: 19, name: "Cards" },
    { id: 20, name: "Cartaz" },
    { id: 21, name: "Pirulitos de Manifestação" },
];

export const ALL_CATEGORIES = "0";

// true quando o valor representa "todas as categorias"
export const isAllCategories = (value) =>
    !value || value === ALL_CATEGORIES || value === "TODAS AS CATEGORIAS";

export const materialCategoryName = (value) => {
    const found = MATERIAL_CATEGORIES.find((c) => String(c.id) === String(value));
    return found ? found.name : value;
};

// monta a query string codificando cada valor e ignorando vazios
export const buildQuery = (params = {}) => {
    const parts = Object.entries(params)
        .filter(([, v]) => v !== undefined && v !== null && v !== "")
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`);

    return parts.length ? `?${parts.join("&")}` : "";
};

/**
 * GET em uma listagem da API. Devolve { items, total }, onde total vem do header
 * X-Total-Count. Quando a API nao envia o header, total e null.
 */
export const fetchList = async (path, params = {}) => {
    const resp = await axios.get(`${API_URL}/${path}${buildQuery(params)}`, {
        headers: HEADERS,
        crossDomain: true,
    });

    const items = Array.isArray(resp.data) ? resp.data : [];
    const raw = resp.headers?.["x-total-count"];
    const headerTotal = raw === undefined || raw === null || raw === "" ? NaN : Number(raw);

    return {
        items,
        total: Number.isFinite(headerTotal) ? headerTotal : null,
    };
};

/**
 * Numero de paginas. Sem total conhecido (API antiga), assume que existe mais uma
 * pagina enquanto a atual vier cheia.
 */
export const pagesFor = ({ total, itemsLength, page, limit }) => {
    if (total !== null && total !== undefined) return totalPagesFor(total, limit);
    return itemsLength < limit ? page : page + 1;
};

/**
 * Fontes possiveis para a capa de uma noticia, em ordem de preferencia.
 * Noticias novas ja trazem a URL completa (S3). As antigas so tem o nome do arquivo:
 * tenta primeiro a copia servida pelo proprio site (/noticias/<ID>/capa/<arquivo>) e
 * depois o servidor do admin. Use com o componente SmartImage, que faz o fallback.
 */
export const newsImage = (item) => {
    const capa = item?.capa;

    if (!capa) return [];

    if (/^https?:\/\//i.test(capa)) return [capa];

    if (!item?.ID) return [];

    const file = encodeURIComponent(capa);

    return [
        `/noticias/${item.ID}/capa/${file}`,
        `https://admin.sindsep-sp.org.br/sistema/noticias/${item.ID}/capa/${file}`,
    ];
};

// imagem de capa de um material
export const materialImage = (item) =>
    item?.capa?.includes("aws")
        ? item.capa
        : `https://materiais-bucket.s3.sa-east-1.amazonaws.com/${item?.ID}/capa/${item?.capa}`;

export const totalPagesFor = (total, limit) => Math.max(1, Math.ceil(total / limit));

export const resultsLabel = (total, singular, plural) => {
    if (total === 0) return `Nenhum resultado`;
    if (total === 1) return `1 ${singular}`;
    return `${total.toLocaleString("pt-BR")} ${plural}`;
};
